export default (template = '', values = {}, wrappers = ['{{', '}}']) => {
  const [leftWrapper, rightWrapper] = wrappers

  return Object
    .keys(values)
    .reduce((output, key) => (
      output.replace(`${leftWrapper}${key}${rightWrapper}`, values[key])
    ), template)
}
